export const InteractionState = {
  OUTSIDE: 0,
  NEAR_CENTER: 1,
  NEAR_AXIS1: 2,
  NEAR_AXIS2: 3,
  ON_CENTER: 4,
  ON_AXIS1: 5,
  ON_AXIS2: 6,
};

export const ManipulationMode = {
  NONE: 0,
  PAN_AND_ROTATE: 1,
  ROTATE_BOTH_AXES: 2,
};
